import React from "react";

const DEFAULT_PROMO = {
  promoType: "all",
  promoCode: ""
};

const promoContext = React.createContext(DEFAULT_PROMO);

export default promoContext;
